import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IWorkState } from ".";
import { Work } from "../../model/work";

export interface IWorkProp {
    value: number;
    level: number;
    maxLevel: number;
    cost: number;
}

export interface IGetWorkStateResponse {
    capacity: IWorkProp;
    storeSpeed: IWorkProp;
    profitRate: IWorkProp;
    energyValue: number;
}

export const getWork = createAsyncThunk<IGetWorkStateResponse>(
    'work/getWork',
    async () => await api.work.getWork()
);

const getWorkHandler = (builder: ActionReducerMapBuilder<IWorkState>) => {
    builder
        .addCase(getWork.pending, (state: IWorkState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getWork.fulfilled, (state: IWorkState, action: PayloadAction<IGetWorkStateResponse>) => {
            state.loading = false;

            state.capacity = action.payload?.capacity ?? null;
            state.storeSpeed = action.payload?.storeSpeed ?? null;
            state.profitRate = action.payload?.profitRate ?? null;

            const energyValue = action.payload?.energyValue ?? 0;

            if (state.storeSpeed)
                state.lastConvertDate = Work.calcClientLastConvertTime(energyValue, state.storeSpeed.value);
        })
        .addCase(getWork.rejected, (state: IWorkState) => {
            state.loading = false;
            state.error = 'Unable to get work';
        });
};

export default getWorkHandler;